import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface PmsEquipmentInstance {
  id: number;
  equipmentId: number;
  statusId: number;
  serialNumber?: string | null;
  manufacturer?: string | null;
  model?: string | null;
  partNumber?: string | null;
  installedLocation?: string | null;
  condition?: string | null;
  notes?: string | null;
  previousInstanceId?: number | null;
  equipment?: {
    id: number;
    equipmentCode?: string;
    name?: string;
  } | null;
  status?: {
    id: number;
    code?: string;
    name?: string;
  } | null;
  previousInstance?: {
    id: number;
    serialNumber?: string | null;
  } | null;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export const usePmsEquipmentInstances = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<PmsEquipmentInstance> | PmsEquipmentInstance[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<PmsEquipmentInstance>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePmsEquipmentInstance = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<PmsEquipmentInstance>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
